import { Outlet, useRoutes } from "react-router-dom";
import HeaderKera from "../Pages/Home/Components/HeaderKera";
import FooterStyle04 from "../Components/Footers/FooterStyle04";
import Home from "../Pages/Home/Home";
import BeneficiaryCorner from "../Pages/BeneficiaryCorner/BeneficiaryCorner";
import Publication from "../Pages/Publication/Publication";
import Notification from "../Pages/Notification/Notification";
import Rti from "../Pages/Rti/Rti";
import Management from "../Pages/Management/Management";
import About from "../Pages/About/About";
import BeneficiaryCornerDetailed from "../Pages/BeneficiaryCornerDetailed/BeneficiaryCornerDetailed";
import Leadership from "../Pages/Leadership/Leadership";
import ContactUs from "../Pages/ContactUs/ContactUs";
import PhotoGallery from "../Pages/PhotoGallery";
import PhotoDetails from "../Pages/PhotoGallery/PhotoDetails";
import VideoGallery from "../Pages/VideoGallery";
import KeraInMedia from "../Pages/KeraInMedia";
import DocumentRepository from "../Pages/DocumentRepository/DocumentRepository";

const AppRoutes = () => {
  const routesElement = useRoutes([
    {
      path: "/", // This is your main layout route
      element: (
        <>
          <HeaderKera />
          <main className="flex-grow ">
            <Outlet /> {/* This Outlet will render Home or BeneficiaryCorner */}
          </main>
          <FooterStyle04
            className="finance-footer"
            theme="light"
            logo="/images/full logo.webp"
          />
        </>
      ),
      children: [
        { element: <Home />, index: true },
        { path: "beneficiary-corner", element: <BeneficiaryCorner /> },
        {
          path: "beneficiary-corner/detailed/:name",
          element: <BeneficiaryCornerDetailed />,
        },
        { path: "team", element: <Management /> },
        { path: "leadership", element: <Leadership /> },
        { path: "publication", element: <Publication /> },
        { path: "photo-gallery", element: <PhotoGallery /> },
        { path: "photo-gallery/details/:id", element: <PhotoDetails /> },
        { path: "video-gallery", element: <VideoGallery /> },
        { path: "kera-in-media", element: <KeraInMedia /> },
        { path: "notifications", element: <Notification /> },
        { path: "document-repository/:title", element: <DocumentRepository /> },
        { path: "rti", element: <Rti /> },
        { path: "about_us", element: <About /> },
        { path: "contact", element: <ContactUs /> },
      ],
    },
    // You can add more top-level routes here if needed (e.g., for different layouts)
    // {
    //   path: '/admin',
    //   element: <AdminLayout />,
    //   children: [
    //     { path: 'dashboard', element: <AdminDashboard /> }
    //   ]
    // }
  ]);

  return routesElement;
};

export default AppRoutes;
